// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__3Gjen","footer":"ModalInfo_footer__31jPK"};